import React from 'react';
import ReactDOM from 'react-dom/client';
import './scss/style.scss';
import './assets/fonts/stylesheet.css';
import 'react-phone-input-2/lib/style.css';
import {BrowserRouter} from 'react-router-dom';
import {Provider} from 'react-redux';
import store from './redux/store';
import App from './App.tsx';
import 'react-range-slider-input/dist/style.css';
import './locales/i18n';
import 'chartjs-adapter-date-fns';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
	<React.StrictMode>
		<Provider store={store}>
			<BrowserRouter basename={'account'}>
				<App />
			</BrowserRouter>
		</Provider>
	</React.StrictMode>,
);
